import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IPropsTableTd {
    customClass?: string | undefined
}

export default /*#__PURE__*/_defineComponent({
  props: {
    customClass: { type: [String, null], required: false, default: undefined }
  },
  setup(__props: any) {

const props = __props as { customClass: string | undefined }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("td", {
    class: _normalizeClass(props.customClass ? [props.customClass] : 'py-2 lg:py-4 px-3 block lg:table-cell ')
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})